<template>
  <div class="Evaluation-modal-overlay">
    <div class="Evaluation-modal" @click.stop>
        <h3 style="font-size: 1.5rem; margin-bottom: 10px;"><strong style="color: red;"><font-awesome-icon class="warning-icon" :icon="['fas', 'exclamation-triangle']" />WARNING!</strong></h3>
        <p>There are {{ insSoCount }} tasks signed off by the trainee with no Instructor Sign Off. Once the Evaluation is complete, these tasks can no longer be signed off <br><br>
          Are you sure you want to continue?
        </p>
      <div class="button-container">
        <button class="ins-close-button" @click="cancelAction">Cancel</button>
        <div class="right">
        <button class="ins-submit-button" @click="confirmContinue">Continue</button>
        </div>
      </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
        insSoCount: {
            type: Number, 
            required: true,
        }
    },
    methods: {
      confirmContinue() {
        this.$emit('confirm'); // Emit event when Continue is clicked
      },
      cancelAction() {
        this.$emit('cancel'); // Emit event when Cancel is clicked
      },
    }
  }
</script>  

<style scoped>
.Evaluation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.Evaluation-modal {
background-color: #ffffff;
overflow-y: auto;
/* Enables vertical scrolling if needed */
margin: 0% auto; /* Center it */
max-height: 85vh;
max-width: 50vw;
min-width: 30vw;
padding: 10px;
border-radius: 8px;
box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
position: fixed;
display: flex;
flex-direction: column;
overflow-wrap: break-word;
padding: 20px;
border: 2px solid red; /* Red border */
}

.button-container {
display: flex;
justify-content: space-between;
/* Aligns items to the right */
align-items: center;
margin-top: 20px;
/* Adjust as needed */
}

.ins-submit-button {
background-color: brown;
border: 1px solid rgb(92, 23, 23);
color: white;
cursor: pointer;
border-radius: 5px;
padding: 5px 20px;
min-width: 120px;
max-width: 150px;
margin-right: 5%;
height: 35px;
}

.ins-close-button {
background-color: #6c757d;
border: 1px solid #4d5358;
color:white;
padding: 5px 20px;
border-radius: 5px;
margin-left: 5%;
}

.ins-close-button:hover {
background-color: #4d5358;
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.right {
    display: flex;
  justify-content: flex-end;
  margin-right: 5%;
}


</style>